import DialogWrapper2 from '../../../../../core/dialog/dialog_wrapper_v2';
import { lazyInject } from '../../../../../services/inversify';
import * as React from 'react';
import { StandorteEigenstromTabs } from '../../../detail/eigenstrom/StandortEigenstromTabs';
import { TriggerService } from '../../../../../core/trigger/trigger_service';
import { WActionButton } from '../../../../../core/elements/WActionButton';

export interface EigenstromButtonWrapperProps {
    data: any;
    onChange?: (data: Array<any>) => void;
    standortSelected: any;
}

export interface EigenstromButtonWrapperState {
    showDialog: boolean;
}

export class EigenstromButtonWrapper extends React.Component<EigenstromButtonWrapperProps, EigenstromButtonWrapperState> {

    constructor(props: any) {
        super(props);
        this.state = {
            showDialog: false,
        };
        this.onTypenChange = this.onTypenChange.bind(this);
    }

    @lazyInject(TriggerService) private triggerService: TriggerService;

    onTypenChange(data: Array<any>): void {
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(data);
        }
    }

    render(): JSX.Element {
        return (
            <>
                <WActionButton
                    label='Auswahl Eigenstrom'
                    insideText='Auswahl Eigenstrom'
                    key='edit'
                    action='edit'
                    onAction={() => this.setState({ showDialog: true })}
                />
                {this.state.showDialog &&
                    <DialogWrapper2
                        width={-1}
                        onAfterClose={() => this.setState({ showDialog: undefined })}
                    >
                        <div style={{ maxWidth: window.innerWidth - 60 }}>
                            <StandorteEigenstromTabs
                                routing={undefined}
                                onRoutingChange={() => { }}
                                standortSelected={this.props.standortSelected}
                                onTypenChange={this.onTypenChange}
                                typeFilter='S'
                                data={this.props.data}
                            />
                        </div>
                    </DialogWrapper2>
                }
            </>
        );
    }
}
